﻿import React, { useState, useEffect } from 'react';
import { PackagingMaterial } from '../../models/Production/packaging-material';
import { ModalMetadata } from '../../models/modal-metadata';
import { ModalMessageType } from '../../models/enums';
import GlobalDialog from '../Modal/GlobalDialog';
import { CrudFunctions } from '../../utilities/crud-functions';

import DataGrid, {
    Column,
    Selection,
    Paging,
    HeaderFilter,
    FilterRow,
    LoadPanel,
    Toolbar,
    Button as ColumnButton,
    Item as ToolbarItem,
    SearchPanel
} from 'devextreme-react/data-grid';

import Button from 'devextreme-react/button';

export interface Props {
    onApplySelection?: (packagingMaterials: PackagingMaterial[]) => void;
    onCancel?: () => void;
}

export default function PackagingMaterialLookupComponent(props: Props) {
    const [packagingMaterials, setPackagingMaterials] =
        useState<PackagingMaterial[]>();

    const [selectedPackagingMaterials, setSelectedPackagingMaterials] =
        useState<PackagingMaterial[]>([]);

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getPackagingMaterials();
    }, []);

    return (
        <div>
            <div>
                <DataGrid 
                    width="100%" height="18rem"
                    dataSource={packagingMaterials ? packagingMaterials : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    keyExpr="packagingMaterialId"
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging enabled={false} />

                    <Selection mode='single' />
                    <HeaderFilter visible={true} />
                    <FilterRow visible={true} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width='3rem' >
                        <ColumnButton icon="plus" onClick={addPackagingMaterialToPackagingMaterials} />
                    </Column>

                    <Column dataField='name' dataType='string' width='15rem' />
                    <Column dataField='description' dataType='string' />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Packaging Materials</div>
                            </div>
                        </ToolbarItem>
                        <ToolbarItem location='after' name="searchPanel" />
                    </Toolbar>

                </DataGrid>
            </div>

            <div className="pw-margin-top-1">
                <DataGrid key="dgd-selected-products"
                    width="100%"
                    dataSource={selectedPackagingMaterials ? selectedPackagingMaterials : []}
                    wordWrapEnabled={true}
                    allowColumnResizing={true}
                    columnResizingMode='widget'
                    rowAlternationEnabled={true}
                    showRowLines={true}
                    showBorders={true}>

                    <LoadPanel enabled={true} />
                    <Paging enabled={false} />

                    <SearchPanel visible={true} />

                    <Column type="buttons" width='3rem' >
                        <ColumnButton icon="trash" onClick={removePackagingMaterialFromSelectedPackagingMaterials} />
                    </Column>

                    <Column dataField='name' dataType='string' width='15rem' />
                    <Column dataField='description' dataType='string' />

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Selected Packaging Materials</div>
                            </div>
                        </ToolbarItem>
                        <ToolbarItem location='after' name="searchPanel" />
                    </Toolbar>
                </DataGrid>
            </div>

            <div className="pw-comp-row" style={{ height: "4rem" }}>
                <div className="pw-centered-buttons-container">
                    <Button id="applySelectionButton"
                        className="pw-button"
                        text="Apply" type="success"
                        hint="apply selection"
                        height='2.1rem'
                        onClick={onApplyClick} />

                    <Button id="cancelButton"
                        className="pw-button"
                        text="Cancel" type="normal"
                        hint="cancel"
                        height='2.1rem'
                        onClick={onCancelClick} />
                </div>
            </div>

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }

        </div>
    );

    function addPackagingMaterialToPackagingMaterials(e: any) {
        if (e.row && e.row.data) {

            setSelectedPackagingMaterials(prevSelectedPackagingMaterials => {
                return [...prevSelectedPackagingMaterials, e.row.data];
            });
        }
    }

    function removePackagingMaterialFromSelectedPackagingMaterials(e: any) {
        console.log("removePackagingMaterialFromSelectedPackagingMaterials()");
        console.log(e);

        if (e.row && e.row.data && e.row.data.packagingMaterialId) {
            let editedSelectedPackagingMaterials = [...selectedPackagingMaterials];

            const filteredPackagingMaterials = editedSelectedPackagingMaterials.filter(s => s.packagingMaterialId !== e.row.data.packagingMaterialId);

            setSelectedPackagingMaterials(filteredPackagingMaterials);
        }
    }

    function onApplyClick(e: any) {
        if (props.onApplySelection)
            props.onApplySelection(selectedPackagingMaterials);
    }

    function onCancelClick(e: any) {
        if (props.onCancel)
            props.onCancel();
    }

    async function getPackagingMaterials() {
        await CrudFunctions.getData("products/packagingmaterials")
            .then(data => {
                setPackagingMaterials(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Packaging Materials");
            });
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }
}

